import React from 'react'
import { DevTool } from '@hookform/devtools'
import { CustomFormProps } from 'types/common'
import { useFormContext } from 'react-hook-form'
import { SimpleForm } from 'react-admin'

export const KDevTool: React.FC = () => {
  const { control } = useFormContext()
  return <DevTool control={control} placement="top-right" />
}

export const KSimpleForm: React.FC<CustomFormProps> = (props) => {
  return (
    <SimpleForm {...props}>
      <KDevTool />
      {props.children}
    </SimpleForm>
  )
}
